export function isRunningLocalhost() {
    return window.location.href.indexOf('localhost') !== -1;
}